
// 要在父级组件的根节点 触发 this.$store.dispatch('orderUser/getUserInfo')

import { getUserInfo } from '@@/api/center'

// 缓存请求，防止同一时间多次重复请求
let requestCache = null

const state = {
  userInfo: {},
  isLogin: false
}

const getters = {
  userInfo(state) {
    return state.userInfo
  },
  isLogin(state) {
    return state.isLogin
  }
}

const mutations = {
  setUserInfo(state, info) {
    state.userInfo = info
  },
  setIsLogin(state, isLogin) {
    state.isLogin = isLogin
  }
}

const actions = {
  async getUserInfo({ commit }) {
    const res = await getUserInfo({})
    if (res && res.retCode == 0) {
      commit('setUserInfo', res.result || {})
      commit('setIsLogin', !!(res.result || {}).sso_uid)
    } else {
      commit('setUserInfo', {})
      // commit('setIsLogin', false)
      commit('setIsLogin', process.env.NODE_ENV === 'development')
    }
  },
  // 获取是否已登录状态
  async getIsLogin({ dispatch, state }) {
    try {
      if (state.isLogin) {
        return true
      }
      if (!requestCache) {
        requestCache = dispatch('getUserInfo')
      }
      await requestCache
      return state.isLogin
    } finally {
      requestCache = null
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}